/* eslint-disable react-hooks/exhaustive-deps */
import {
  updateSalesContractApi,
  getSaleContractQualitySpecificationSuggestionApi,
  getSalesContractDocumentSuggestionApi,
} from "../../../services/_sales";
import {
  initialSalesContractProducts,
  salesContractInitialValues,
  SalesContractProducts,
  salesContractValidationSchema,
} from "./helpers/SalesContractHelper";
import moment from "moment";
import { Formik, Form, FieldArray } from "formik";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BasicFields from "./sales-contract-form/BasicFields";
import ActionFields from "./sales-contract-form/ActionFields";
import { getBuyerNameListApi } from "../../../services/_buyer";
import { getAllDocumentApi } from "../../../services/_document";
import ProductFields from "./sales-contract-form/ProductFields";
import ShipmentFields from "./sales-contract-form/ShipmentFields";
import DocumentFields from "./sales-contract-form/DocumentFields";
import { getChildProductNameListApi } from "../../../services/_product";
import { errorToast, successToast } from "../../../components/Toast";
import { getAllQualitySpecificationsApi } from "../../../services/_qualitySpecifications";
import QualitySpecificationFields from "./sales-contract-form/QualitySpecificationFields";
import { getAllBrokerApi } from "../../../services/_broker";
import { getAllUnitsApi } from "../../../services/_unit";
import { getAllPackingTypesApi } from "../../../services/_packingTypes";
import AddUnitModal from "../../../components/modal/AddUnit";
import AddPackingType from "../../../components/modal/AddPackingType";
import MarkingFields from "./sales-contract-form/MarkingFields";
import AddBuyerModal from "../../../components/modal/AddBuyer";
import AddBrokerModal from "../../../components/modal/AddBroker";
import AddProductModal from "../../../components/modal/AddProduct";
import AddQualitySpecificationModal from "../../../components/modal/AddQualitySpecification";
import AddDocumentModal from "../../../components/modal/AddDocument";
import BankFields from "./sales-contract-form/BankFields";
import { getAllBankListApi } from "../../../services/_bank";
import { BankType } from "../../../components/Enums";
import AddBankModal from "../../../components/modal/AddBank";
import GeneralTermsFields from "./sales-contract-form/GeneralTermsFields";
import { getAllGeneralTermsByProductIdApi } from "../../../services/_generalTerms";
import { getSalesContractDetailsWithUsedQty } from "../sales-invoice/helpers/SalesInvoiceHelperFunction";
import { getAllPortsApi } from "../../../services/_port";
import AddPortModal from "../../../components/modal/AddPort";
import OtherFields from "./sales-contract-form/OtherFields";
import SupplierProducts from "./sales-contract-form/SupplierProducts";
import { getAllPurchasesApi } from "../../../services/_purchase";
import { getSupplierNameListApi } from "../../../services/_supplier";
import { getPermissions } from "../../../context/AuthContext";
import TotalFields from "./sales-contract-form/TotalFields";

interface ProductType {
  id: string;
  name: string;
  variety?: string | null;
  description?: string | null;
  hsn_no?: string | null;
  parent_product_id?: string | null;
}

const EditSalesContract = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const permissions = getPermissions();
  const [buyerId, setBuyerId] = useState("");
  const [buyerList, setBuyerList] = useState([]);
  const [brokerList, setBrokerList] = useState([]);
  const [productList, setProductList] = useState<ProductType[]>([]);
  const [unitList, setUnits] = useState<any[]>([]);
  const [portList, setPortList] = useState([]);
  const [qualitySpecificationsList, setQualitySpecificationsList] =
    useState<any>([]);
  const [qltSuggestionList, setQltSuggestionList] = useState([]);
  const [packingType, setPackingType] = useState<any[]>([]);
  const [documentList, setDocumentList] = useState([]);
  const [documentSuggestionList, setDocumentSuggestionList] = useState([]);
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>(
    salesContractInitialValues,
  );
  const [addPackingTypeModalStatus, setAddPackingTypeModalStatus] =
    useState(false);
  const [addUnitModalStatus, setAddUnitModalStatus] = useState(false);
  const [filePondFiles, setFilePondFiles] = useState([]);
  const [addBrokerModalStatus, setAddBrokerModalStatus] = useState(false);
  const [addBuyerModalStatus, setAddBuyerModalStatus] = useState(false);
  const [addProductModalStatus, setAddProductModalStatus] = useState(false);
  const [addPortModalStatus, setAddPortModalStatus] = useState(false);
  const [
    addQualitySpecificationModalStatus,
    setAddQualitySpecificationModalStatus,
  ] = useState(false);
  const [addDocumentModalStatus, setAddDocumentModalStatus] = useState(false);
  const [exporterBankList, setExporterBankList] = useState([]);
  const [buyerBankList, setBuyerBankList] = useState([]);
  const [addBankModal, setAddBankModal] = useState(false);
  const [bankType, setBankType] = useState<string>("");
  const [generalTermsList, setGeneralTermsList] = useState<any[]>([]);
  const [productWiseUsedQty, setProductWiseUsedQty] = useState<{
    [product_id: string]: number;
  }>({});
  const [purchaseOrderList, setPurchaseOrderList] = useState<any[]>([]);
  const [supplierList, setSupplierList] = useState<any[]>([]);
  const [supplierProductsQtyData, setSupplierProductsQtyData] = useState<any>(
    [],
  );

  useEffect(() => {
    if (!id) {
      navigate("/sales-contract-list");
    }
  });

  const fetchInitialData = async () => {
    const result: any = await getSalesContractDetailsWithUsedQty(id as string);

    if (result) {
      const { sales_contract: data } = result;
      const transformedData = {
        ...salesContractInitialValues,
        contract_no: data.contract_no || "",
        reference_no: data.reference_no || "",
        contract_date: data.contract_date ? new Date(data.contract_date) : null,
        buyer_id: data.buyer_id || "",
        broker_id: data.broker_id || "",
        status: data.status,
        currency: data.currency,

        sales_contract_products: data.sales_contract_product || [],
        sub_total: data.sub_total || "",
        total_no_of_bags: data.total_no_of_bags || "",
        total_net_weight: data.total_net_weight || "",
        total_gross_weight: data.total_gross_weight || "",

        marking: data.marking || "",
        marking_existing_files: data.marking_files,
        marking_files: [],
        final_destination: data.final_destination || "",
        port_of_loading_id: data.port_of_loading_id || "",
        port_of_discharge: data.port_of_discharge || "",
        shipment: data.shipment || "",
        trans_shipment: data.trans_shipment || "",
        partial_shipment: data.partial_shipment || "",
        payment_terms: data.payment_terms || "",
        delivery_terms: data.delivery_terms || "",
        weight_and_quality: data.weight_and_quality || "",
        arbitration: data.arbitration || "",
        is_digital_signature: data.is_digital_signature ? 1 : 0,
        quality_specification: data.quality_specifications || [],
        document: data.documents || [],
        exporter_bank_id: data.exporter_bank_id || "",
        buyer_bank_id: data.buyer_bank_id || "",
        general_terms:
          data.general_terms?.map((item: any) => item.general_term_id) || [],
        // sales_contract_supplier_products:
        //   data?.sales_contract_supplier_products.map((supplierProduct: any) => {
        //     return {
        //       ...supplierProduct,
        //       supplier_id: supplierProduct.purchase.supplier_id,
        //     };
        //   }) || [],
      };
      setInitialValues(transformedData);
      setProductWiseUsedQty(result.productWiseUsedQty);
      setBuyerId(data.buyer_id || "");
      setSupplierProductsQtyData(data.productWiseRemainingQty);

      const allBuyers: any = await getBuyerNameListApi();
      setBuyerId(data.buyer_id || "");
      if (allBuyers.isSuccess) {
        setBuyerList(allBuyers.data);
      }
      const allBrokers: any = await getAllBrokerApi();
      if (allBrokers.isSuccess) {
        setBrokerList(allBrokers.data);
      }
      const allProducts: any = await getChildProductNameListApi();
      let productListData: ProductType[] = [];

      if (allProducts.isSuccess) {
        productListData = allProducts.data;
        setProductList(productListData);
      }
      const allDocuments: any = await getAllDocumentApi();
      if (allDocuments.isSuccess) {
        setDocumentList(allDocuments.data);
      }
      // const allUnits: any = await getAllUnitsApi();
      // if (allUnits.isSuccess) {
      //   setUnits(allUnits.data);
      // }
      const allPackingType: any = await getAllPackingTypesApi();
      if (allPackingType.isSuccess) {
        setPackingType(allPackingType.data);
      }
      const allPorts: any = await getAllPortsApi();
      if (allPorts.isSuccess) {
        setPortList(allPorts.data);
      }
      const allExporterBanks: any = await getAllBankListApi(
        `type=${BankType.EXPORTER}`,
      );
      if (allExporterBanks.isSuccess) {
        setExporterBankList(allExporterBanks.data);
      }

      // let productIds =
      //   data.sales_contract_product?.map((item: any) => item.product_id) || [];

      const childProductIds =
        data.sales_contract_product?.map((item: any) => item.product_id) || [];

      const parentProductIds = childProductIds
        .map((childId: string) => {
          const product = productListData.find(
            (p: ProductType) => p.id === childId,
          );
          return product?.parent_product_id || product?.id;
        })
        .filter(Boolean);

      const uniqueParentIds = Array.from(new Set(parentProductIds));

      if (uniqueParentIds?.length > 0) {
        const query = `product_id=[${uniqueParentIds.join(",")}]`;

        const qltSuggestion: any =
          await getSaleContractQualitySpecificationSuggestionApi(query);
        if (qltSuggestion.isSuccess) {
          setQltSuggestionList(qltSuggestion?.data || []);
        }

        const allQualitySpecs: any =
          await getAllQualitySpecificationsApi(query);
        if (allQualitySpecs.isSuccess) {
          setQualitySpecificationsList(allQualitySpecs.data);
        }

        const documentSuggestionList: any =
          await getSalesContractDocumentSuggestionApi(query);
        if (documentSuggestionList.isSuccess) {
          setDocumentSuggestionList(documentSuggestionList?.data || []);
        }

        const getGeneralTermsByProductId: any =
          await getAllGeneralTermsByProductIdApi(query);
        if (getGeneralTermsByProductId.isSuccess) {
          setGeneralTermsList(getGeneralTermsByProductId?.data || []);
        }
      }

      const allPurchaseOrders: any = await getAllPurchasesApi();
      if (allPurchaseOrders.isSuccess) {
        setPurchaseOrderList(allPurchaseOrders.data);
      }
      const allSuppliers: any = await getSupplierNameListApi();
      if (allSuppliers.isSuccess) {
        setSupplierList(allSuppliers.data);
      }
    } else {
      errorToast("Unable to fetch Sales Contract Data");
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchBuyerBankDetails = async (buyerId: string) => {
    if (buyerId) {
      const allBuyerBanks: any = await getAllBankListApi(
        `type=${BankType.BUYER}&relation_id=${buyerId}`,
      );
      if (allBuyerBanks.isSuccess) {
        setBuyerBankList(allBuyerBanks.data);
      }
    } else {
      setBuyerBankList([]);
    }
  };

  useEffect(() => {
    fetchBuyerBankDetails(buyerId);
  }, [buyerId]);

  const handleChangeProduct = async (
    updatedProductIds: string[],
    values: any,
    setFieldValue: any,
    oldProductId: any,
    changedIndex?: number,
  ) => {
    if (changedIndex === undefined) return;
    const newProductId =
      values.sales_contract_products[changedIndex]?.product_id;

    const newProduct = productList.find((p: any) => p.id === newProductId);
    const oldProduct = productList.find((p: any) => p.id === oldProductId);

    const newParentId = newProduct?.parent_product_id || newProduct?.id;
    const oldParentId = oldProduct?.parent_product_id || oldProduct?.id;

    if (oldProductId && newParentId !== oldParentId) {
      const resetFields = {
        price: "",
        quantity: "",
        total_amount: "",
        no_of_containers: "",
        container_load: "",
        no_of_bags: "",
        packing_type_id: "",
        packing_net_weight: "",
        total_net_weight: "",
        packing_gross_weight: "",
        total_gross_weight: "",
      };

      Object.entries(resetFields).forEach(([key, value]) => {
        setFieldValue(
          `sales_contract_products.${changedIndex}.${key}`,
          value,
          false,
        );
      });
    }
    const parentProductIds = updatedProductIds
      .map((childId: string) => {
        const product = productList.find((p: ProductType) => p.id === childId);
        return product?.parent_product_id || product?.id;
      })
      .filter(Boolean);

    const uniqueParentIds = Array.from(new Set(parentProductIds));
    // Handle QualitySpecification Input Field Data
    if (
      qualitySpecificationsList.length > 0 &&
      values?.quality_specification?.length > 0 &&
      setFieldValue
    ) {
      // REMOVE FIELDS
      const updatedQualitySpecificationValue =
        values.quality_specification.filter((value: any) => {
          const foundSpecification = qualitySpecificationsList.find(
            (listData: any) => listData.id === value.quality_specification_id,
          );
          return (
            foundSpecification &&
            uniqueParentIds.includes(foundSpecification.product_id)
          );
        });
      setFieldValue("quality_specification", updatedQualitySpecificationValue);
    }
    // Handle General Terms Input Field Data
    if (
      generalTermsList.length > 0 &&
      values?.general_terms?.length > 0 &&
      setFieldValue
    ) {
      const updatedGeneralTermsValue = values.general_terms.filter(
        (termId: string) => {
          const term = generalTermsList.find(
            (listData: any) => listData.id === termId,
          );
          return term && uniqueParentIds.includes(term.product_id);
        },
      );
      setFieldValue("general_terms", updatedGeneralTermsValue);
    }

    if (uniqueParentIds?.length > 0) {
      const query = `product_id=[${uniqueParentIds.join(",")}]`;

      const allQualitySpecs: any = await getAllQualitySpecificationsApi(query);
      if (allQualitySpecs?.isSuccess) {
        setQualitySpecificationsList(allQualitySpecs?.data);
      }

      const qltSuggestion: any =
        await getSaleContractQualitySpecificationSuggestionApi(query);
      if (qltSuggestion?.isSuccess) {
        setQltSuggestionList(qltSuggestion?.data);
      }

      const documentSuggestionList: any =
        await getSalesContractDocumentSuggestionApi(query);
      if (documentSuggestionList?.isSuccess) {
        setDocumentSuggestionList(documentSuggestionList?.data);
      }

      const allGeneralTermsByProductId: any =
        await getAllGeneralTermsByProductIdApi(query);
      if (allGeneralTermsByProductId?.isSuccess) {
        setGeneralTermsList(allGeneralTermsByProductId?.data);
      }
    } else {
      setQualitySpecificationsList([]);
      setQltSuggestionList([]);
      setDocumentSuggestionList([]);
      setGeneralTermsList([]);
    }

    // Handle supplier products data
    // const updatedSupplierProducts =
    //   values.sales_contract_supplier_products.filter(
    //     (supplierProduct: any) => supplierProduct.product_id !== oldProductId
    //   );
    // setFieldValue(`sales_contract_supplier_products`, updatedSupplierProducts);
  };

  const closeAddUnitModal = () => {
    setAddUnitModalStatus(false);
  };

  const closePackingTypeModal = () => {
    setAddPackingTypeModalStatus(false);
  };

  const closeAddBuyerModal = () => {
    setAddBuyerModalStatus(false);
  };

  const closeAddBrokerModal = () => {
    setAddBrokerModalStatus(false);
  };

  const closeAddProductModal = () => {
    setAddProductModalStatus(false);
  };

  const closeAddPortModal = () => {
    setAddPortModalStatus(false);
  };

  const closeAddQualitySpecificationModal = () => {
    setAddQualitySpecificationModalStatus(false);
  };

  const closeAddDocumentModal = () => {
    setAddDocumentModalStatus(false);
  };

  const openAddBankModal = (isOpen: boolean, type: string) => {
    setBankType(type);
    setAddBankModal(isOpen);
  };

  const closeAddBankModal = () => {
    setAddBankModal(false);
  };

  const handleFileChange = useCallback((fileItems: any, setFieldValue: any) => {
    const files = fileItems
      .map((fileItem: any) => {
        if (fileItem?.file) {
          return {
            fileName: fileItem.file.name,
            fileData: fileItem.getFileEncodeDataURL(), // Encodes to base64
          };
        }
        return null;
      })
      .filter(Boolean);
    setFieldValue("marking_files", files);
  }, []);

  const handleSubmit = async (values: any, { resetForm }: any) => {
    values.contract_date = moment(values.contract_date).format("YYYY-MM-DD");
    values.sub_total = parseFloat(values.sub_total);
    values.is_digital_signature = values?.is_digital_signature ? true : false;
    setSubmitLoader(true);
    const result: any = await updateSalesContractApi(id as string, values);
    if (result.isSuccess) {
      setSubmitLoader(false);
      successToast(result.message);
      resetForm({ values: initialValues });
      navigate(`/sales-contract-list`);
    } else {
      setSubmitLoader(false);
      errorToast(result.message);
    }
    return;
  };

  return (
    <>
      <div className="card">
        <div className="card-header pb-0 d-flex justify-content-between">
          <div>
            <h5>Edit Sales Contract</h5>
          </div>
        </div>
        <div className="card-body">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={salesContractValidationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              handleChange,
              setFieldValue,
              errors,
              touched,
              setFieldError,
            }) => {
              return (
                <Form className="dt_adv_search">
                  <div className="row g-3">
                    <BasicFields
                      buyerList={buyerList}
                      brokerList={brokerList}
                      setBuyerId={setBuyerId}
                      values={values}
                      setFieldValue={setFieldValue}
                      setAddBuyerModalStatus={setAddBuyerModalStatus}
                      handleChange={handleChange}
                      setAddBrokerModalStatus={setAddBrokerModalStatus}
                      permissions={permissions}
                    />

                    <div>
                      <label
                        htmlFor="products"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Add Products: <span className="text-danger">*</span>
                      </label>
                      <div>
                        <FieldArray name="sales_contract_products">
                          {({ remove }) => (
                            <>
                              {values.sales_contract_products.map(
                                (
                                  item: SalesContractProducts,
                                  index: number,
                                ) => (
                                  <ProductFields
                                    key={index}
                                    index={index}
                                    item={item}
                                    remove={remove}
                                    unitList={unitList}
                                    productList={productList}
                                    packingType={packingType}
                                    values={values}
                                    setFieldValue={setFieldValue}
                                    handleChange={handleChange}
                                    // calculateTotalAmount={calculateTotalAmount}
                                    setAddUnitModalStatus={
                                      setAddUnitModalStatus
                                    }
                                    setAddPackingTypeModalStatus={
                                      setAddPackingTypeModalStatus
                                    }
                                    setAddProductModalStatus={
                                      setAddProductModalStatus
                                    }
                                    handleChangeProduct={handleChangeProduct}
                                    productWiseUsedQty={productWiseUsedQty}
                                    setFieldError={setFieldError}
                                    errors={errors}
                                    permissions={permissions}
                                  />
                                ),
                              )}

                              <div className="row mb-1 g-1 px-3 col-12 col-sm-6 col-lg-3">
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => {
                                    const newItems = [
                                      ...values.sales_contract_products,
                                      { ...initialSalesContractProducts },
                                    ];
                                    setFieldValue(
                                      "sales_contract_products",
                                      newItems,
                                    );
                                  }}
                                >
                                  Add Product
                                </button>
                              </div>
                            </>
                          )}
                        </FieldArray>

                        {errors.sales_contract_products &&
                          touched.sales_contract_products &&
                          typeof errors.sales_contract_products ===
                            "string" && (
                            <div className="text-danger">
                              {errors.sales_contract_products}
                            </div>
                          )}
                      </div>
                    </div>

                    <TotalFields values={values} handleChange={handleChange} />

                    <MarkingFields
                      actionType={"update"}
                      values={values}
                      handleChange={handleChange}
                      filePondFiles={filePondFiles}
                      setFilePondFiles={setFilePondFiles}
                      handleFileChange={handleFileChange}
                      setFieldValue={setFieldValue}
                    />

                    <ShipmentFields
                      portList={portList}
                      values={values}
                      setAddPortModalStatus={setAddPortModalStatus}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      permissions={permissions}
                    />

                    <QualitySpecificationFields
                      values={values}
                      setAddQualitySpecificationModalStatus={
                        setAddQualitySpecificationModalStatus
                      }
                      qualitySpecificationsList={qualitySpecificationsList}
                      qltSuggestionList={qltSuggestionList}
                      setFieldValue={setFieldValue}
                      permissions={permissions}
                    />

                    <DocumentFields
                      values={values}
                      setAddDocumentModalStatus={setAddDocumentModalStatus}
                      documentList={documentList}
                      documentSuggestionList={documentSuggestionList}
                      setFieldValue={setFieldValue}
                      permissions={permissions}
                    />

                    {/* <SupplierProducts
                      values={values}
                      productList={productList}
                      purchaseOrderList={purchaseOrderList}
                      supplierList={supplierList}
                      supplierProductsQtyData={supplierProductsQtyData}
                      setSupplierProductsQtyData={setSupplierProductsQtyData}
                      unitList={unitList}
                      setFieldValue={setFieldValue}
                      setFieldError={setFieldError}
                      errors={errors}
                    /> */}

                    <BankFields
                      exporterBankList={exporterBankList}
                      buyerBankList={buyerBankList}
                      openAddBankModal={openAddBankModal}
                      values={values}
                      handleChange={handleChange}
                      permissions={permissions}
                    />

                    <GeneralTermsFields
                      values={values}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      generalTermsList={generalTermsList}
                    />

                    <OtherFields
                      values={values}
                      setFieldValue={setFieldValue}
                    />

                    <ActionFields submitLoader={submitLoader} />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
      <AddUnitModal
        addUnitModalStatus={addUnitModalStatus}
        closeAddUnitModal={closeAddUnitModal}
        onUnitCreated={fetchInitialData}
      />
      <AddPackingType
        addPackingTypeModalStatus={addPackingTypeModalStatus}
        closePackingTypeModal={closePackingTypeModal}
        onPackingTypeCreated={fetchInitialData}
      />
      <AddBuyerModal
        addBuyerModal={addBuyerModalStatus}
        closeAddBuyerModal={closeAddBuyerModal}
        onBuyerCreated={fetchInitialData}
      />
      <AddBrokerModal
        addBrokerModal={addBrokerModalStatus}
        closeAddBrokerModal={closeAddBrokerModal}
        onBrokerCreated={fetchInitialData}
      />
      <AddProductModal
        addProductModalStatus={addProductModalStatus}
        closeAddProductModal={closeAddProductModal}
        onProductCreated={fetchInitialData}
      />
      <AddPortModal
        addPortModal={addPortModalStatus}
        closeAddPortModal={closeAddPortModal}
        onPortCreated={fetchInitialData}
      />
      <AddQualitySpecificationModal
        addQualitySpecificationModal={addQualitySpecificationModalStatus}
        closeAddQualitySpecificationModal={closeAddQualitySpecificationModal}
        onQualitySpecificationCreated={fetchInitialData}
      />
      <AddDocumentModal
        addDocumentModal={addDocumentModalStatus}
        closeAddDocumentModal={closeAddDocumentModal}
        onDocumentCreated={fetchInitialData}
      />
      <AddBankModal
        addBankModal={addBankModal}
        closeAddBankModal={closeAddBankModal}
        onBankCreated={() => {
          fetchBuyerBankDetails(buyerId);
          fetchInitialData();
        }}
        selectedBuyerId={buyerId}
        type={bankType}
      />
    </>
  );
};

export default EditSalesContract;
